import React from 'react'
import NoEstateFound from './NoEstateFound'

const EstateCardList = ({style, children}) => {
  const nbChildren = React.Children.count(children)
  return <ul className="estate-list" style={{...style}}>

    {nbChildren > 0 ? children : <NoEstateFound/>}
  </ul>
}

export default EstateCardList



/** WEBPACK FOOTER **
 ** ./app/components/EstateCardList.jsx
 **/